import React from 'react';
import _classNames from 'classnames';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useSiteCopySelector from 'components/useSiteCopySelector';
import ContactForm from './ContactForm';

const useStyles = makeStyles(theme => ({
  wrapper: {
    position: 'relative',
    backgroundColor: 'rgba(237,248,255,0.52)',
    display: 'flex',
  },
  stickyBackground: {
    backgroundImage: props => `url(${props.backgroundImage})`,
    width: '90%',
    gridRow: 1,
    gridColumn: 1,
    position: 'sticky',
    top: 0,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundAttachment: 'fixed',
    backgroundPosition: 'top',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  container: {
    width: '100%',
    maxWidth: 1080,
    marginLeft: 'auto',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      marginRight: 'auto',
    },
  },
  formWrapper: {
    padding: 40,
    boxShadow: '0px 12px 18px -6px rgb(0 0 0 / 8%)',
    backgroundColor: '#FFFFFF',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: 32,
    },
  },
  h1: {
    fontFamily: 'PoppinsBold',
    fontWeight: '700',
    fontSize: 26,
    lineHeight: '1em',
    textAlign: 'left',
    paddingBottom: 10,
    color: '#333333',
  },
  body: {
    textAlign: 'left',
    fontSize: 14,
    lineHeight: '23.8px',
    fontFamily: 'OpenSansRegular',
    color: '#666666',
    '& > b': {
      fontFamily: 'OpenSansBold',
    },
    paddingBottom: '1em',
  },
  header: {
    fontFamily: 'OpenSansRegular',
    fontWeight: 500,
    fontSize: 18,
    lineHeight: '18px',
    color: '#000000',
    marginTop: 36,
  },
  button: {
    backgroundColor: '#FDA44F',
    borderRadius: 5,
    fontFamily: 'OpenSansBold',
    fontSize: 13,
    padding: '6px 16px',
    color: '#FFFFFF',
    display: 'inline-block',
    marginTop: 10,
  },
  option: {
    fontFamily: 'OpenSansRegular',
    fontSize: 14,
    color: '#666666',
    fontStyle: 'italic',
  },
  member: {
    fontFamily: 'OpenSansRegular',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '23.8px',
    color: '#666666',
    marginTop: '1em',
  },
  contact: {
    fontFamily: 'OpenSansBold',
    fontSize: 14,
    color: '#666666',
    marginTop: 4,
    '& a': {
      color: '#2EA3F2',
    },
  },
  divider: {
    height: 1,
    width: '100%',
    backgroundColor: '#01619B',
    marginTop: '5.82%',
    marginBottom: 'calc(5.82% + 30px)',
  },
  marginBottom: {
    marginBottom: '5.82%',
  },
}));

function ContactSection() {
  const [solutionsSiteCopy] = useSiteCopySelector(['solutions-homepage']);
  const config = _get(solutionsSiteCopy, 'pageCopy.contact-section', {});
  const classes = useStyles({
    backgroundImage: config.image,
  });

  return (
    <section id="cta">
      <div className={classes.wrapper}>
        <div className={classes.stickyBackground} />
        <div className={classes.container}>
          <div className={classes.formWrapper}>
            <Typography className={classes.h1}>{config.title}</Typography>
            <Typography
              className={_classNames(classes.body, classes.marginBottom)}
            >
              {config.formIntro}
            </Typography>
            <ContactForm form={config.form} submitLabel={config.submitLabel} />
            <div className={classes.divider} />
            <Typography className={classes.h1}>{config.teamIntro}</Typography>
            {config.team.map(segment => (
              <>
                <Typography className={classes.header}>
                  {segment.header}
                </Typography>
                <a href={segment.link} target="_blank">
                  <span className={classes.button}>{segment.label}</span>
                </a>
                {_get(segment, 'members', []).map(member => (
                  <>
                    <Typography className={classes.member}>
                      {member.name}
                    </Typography>
                    <Typography className={classes.contact}>
                      <b>
                        <a
                          href={`tel:${member.phone}`}
                        >{`(${member.phone.substring(
                          0,
                          3,
                        )}) ${member.phone.substring(
                          3,
                          6,
                        )}-${member.phone.substring(6)}`}</a>
                        &nbsp;&#9679;&nbsp;
                        <a href={`mailto:${member.email}`}>{member.email}</a>
                      </b>
                    </Typography>
                  </>
                ))}
              </>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
